import * as React from "react";
import MaskedInput from 'react-text-mask';

export default class TextBox extends React.Component {
  static defaultProps = {
    onKeyPress: () => {},
    autoComplete: ''
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  handleChange(event) {
    this.props.onChange(event.target.value, event.target.name);
  }

  handleKeyPress(event) {
    this.props.onKeyPress(event);
  }

  unmask(val) {
    return val.replace(/\D+/g, '');
  }

  render() {
    const {
      masked,
      mask,
      classes,
      name,
      type,
      placeholder,
      value,
      disabled,
      styles,
      onChange,
    } = this.props;

    return (
      masked ?
        <MaskedInput
          mask={mask}
          className={"textbox " + (classes ? classes : "")}
          type={type ? type : 'text'}
          placeholder={placeholder}
          name={name}
          onChange={event => onChange(this.unmask(event.target.value))}
          autoComplete="foo"
          value={value || ''}
          style={styles}
        /> :
        <input
          className={"textbox " + (classes ? classes : "")}
          name={name}
          type={type ? type : "text"}
          placeholder={placeholder}
          value={value ? value : ""}
          onChange={this.handleChange}
          onKeyPress={this.handleKeyPress}
          disabled={disabled}
          autoComplete={this.props.autoComplete}
          style={styles}
        />
    );
  }
}



// WEBPACK FOOTER //
// ./src/theme/TextBox.js